import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Stethoscope, Calendar } from 'lucide-react';
import { WA_LINK } from '../lib/constants';
export function Process() {
  const steps = [{
    icon: <MessageCircle size={32} data-id="element-118" />,
    title: 'Escríbenos por WhatsApp',
    text: 'Cuéntanos brevemente qué necesitas o qué molestia tienes.'
  }, {
    icon: <Stethoscope size={32} data-id="element-119" />,
    title: 'Recibe orientación inicial',
    text: 'Te indicamos cómo avanzar y qué información puede ser útil para revisar tu caso.'
  }, {
    icon: <Calendar size={32} data-id="element-120" />,
    title: 'Agenda tu atención',
    text: 'Coordina una consulta dental para recibir una evaluación profesional.'
  }];
  return <section className="bg-brand-light py-20 lg:py-28" data-id="element-121">
      <div className="container mx-auto px-4 md:px-6" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-16 text-center" data-id="element-123">
          <h2 className="text-3xl font-bold tracking-tight text-brand-dark sm:text-4xl" data-id="element-124">
            ¿Cómo funciona?
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-125">
            Un proceso simple y directo para tu atención dental.
          </p>
        </motion.div>

        <div className="relative mx-auto max-w-5xl" data-id="element-126">
          {/* Connecting line for desktop */}
          <div className="absolute top-12 left-0 hidden h-0.5 w-full bg-slate-200 md:block" data-id="element-127"></div>

          <div className="grid gap-10 md:grid-cols-3" data-id="element-128">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative text-center" data-id="element-129">
                <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-white text-brand-dark shadow-lg ring-8 ring-brand-light relative z-10" data-id="element-130">
                  {step.icon}
                  <div className="absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-brand-accent text-sm font-bold text-white shadow-sm" data-id="element-131">
                    {index + 1}
                  </div>
                </div>
                <h3 className="mb-3 text-xl font-semibold text-brand-dark" data-id="element-132">
                  {step.title}
                </h3>
                <p className="text-slate-600" data-id="element-133">{step.text}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-134">
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-accent px-8 py-4 text-base font-semibold text-white shadow-lg transition-all hover:bg-brand-accentHover hover:-translate-y-0.5" data-id="element-135">
            <MessageCircle size={20} data-id="element-136" />
            Comenzar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}